const LOCALE_PATTERN = /^[a-z][a-z](?:-[a-z][a-z])?$/i;

/** Reads a two-letter `lang` query parameter such as `de` or `de-de` and canonicalizes its casing (`de-DE`). */
export const findLocaleFromUrl = (search: string) => {
   const lang = new URLSearchParams(search).get('lang')?.trim();

   return lang && LOCALE_PATTERN.test(lang) ? Intl.getCanonicalLocales(lang)[0] : null;
};
